import { render, staticRenderFns } from "./pige_dingdan.vue?vue&type=template&id=5d096b2d&"
import script from "./pige_dingdan.vue?vue&type=script&lang=js&"
export * from "./pige_dingdan.vue?vue&type=script&lang=js&"
import style0 from "./pige_dingdan.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports